module.exports = __webpack_public_path__ + "f12195127929ff47a80372ee3c88e85f.png";